export default __webpack_public_path__ + "static/media/caller_id.51e19bb9.svg";